import { AnnualFeeModes } from "utils/constants";

export const CALCULATED_FEE_FIELDS = [
  "baseNormEuro",
  "stateFeeEuro",
  "professionalFieldCoefficient",
  "compositeAssessmentCoefficient",
  "discountAmountEuro",
];

export const euroFormat = value => (typeof value === "number" ? value.toFixed(2) : "");

export const euroParse = value => {
  if (typeof value !== "string") return value;
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const deriveFeeMode = fee => {
  if (CALCULATED_FEE_FIELDS.some(field => fee?.[field] != null)) return AnnualFeeModes.Calculated;
  return fee?.fixedAmountEuro == null ? AnnualFeeModes.Calculated : AnnualFeeModes.Fixed;
};

export const resolveFeeMode = (feeMode, fee) => (feeMode == null ? deriveFeeMode(fee) : Number(feeMode));

export const MIN_ADMISSION_YEAR = 2000;

export const getMaxAdmissionYear = () => new Date().getFullYear() + 1;

/**
 * The admission year of the plan currently loaded in the form. The backend stamps it on every row of a plan,
 * so any row answers it. Undefined for a speciality that has no fees yet - the backend then defaults to the
 * current calendar year.
 */
export const deriveCurrentAdmissionYear = record =>
  record?.stateEducationFees?.[0]?.admissionYear ?? record?.paidEducationFees?.[0]?.admissionYear ?? undefined;
